import { mapImage } from '@/helpers/strapi-assets-helpers';
import type { CategoryModel, StrapiResponseModel } from '@/interfaces/model';
import type { Category, StrapiListResponse } from '@/interfaces/strapi';

export const categoryMapper = (c: CategoryModel): Category => ({
	id: c.documentId,
	name: c.name,
	description: c.description,
	slug: c.slug,
	image: c.image ? mapImage(c.image, 'full') : { url: '', alt: c.name },
});

export const categoryListMapper = (res: StrapiResponseModel<CategoryModel>): StrapiListResponse<Category> => {
	const list = (res.data ?? []).map(categoryMapper);

	const pagination = res.meta?.pagination ?? {
		page: 1,
		pageSize: list.length,
		pageCount: 1,
		total: list.length,
	};

	return { list, pagination };
};
